/** Waitlist section copy — Spanish-only. */

export const waitlistCopy = {
  eyebrow: 'Lista de espera',
  title: 'Te aviso cuando Nyx esté <em>listo para escuchar</em>.',
  lede: 'Una sola dirección, sin mailing semanal. Te aviso cuando lance al App Store o cuando un disco esté listo para entrar.',
  meta: [
    { label: 'Cadencia', value: 'Solo cuando hay algo real que decir.' },
    { label: 'Acceso', value: 'Acceso a la beta antes del lanzamiento.' },
    {
      label: 'Calidad',
      value: 'Análisis original, hecho con cuidado por humanos. La IA ayuda, no reemplaza.',
    },
  ],
  formEyebrow: 'Apuntate',
  fields: {
    favoriteArtist: { label: 'Artista favorito', placeholder: 'Iron Maiden, BTS, Kendrick Lamar, Dua Lipa...' },
    email: { label: 'Email', placeholder: 'tu@correo.com' },
  },
  submit: 'Avísame',
  submitSending: 'Enviando…',
  submitSent: '✓ En la lista',
  errorGeneric: 'No se pudo guardar. Intenta de nuevo.',
  errorEmail: 'Email inválido.',
  fine: 'Tus datos se quedan acá y en el proveedor de email transaccional. No vendemos nada.',
} as const;
